export default __webpack_public_path__ + "static/media/contact.67ee627b.svg";